import CircleLabel from "./CircleLabel.component";

export default CircleLabel;
